import React, { useMemo } from 'react';
import { useTable } from "react-table"
import { Stack } from '@mui/system';
import { Table } from "reactstrap"

const ReturnShipmentTable = ({ 
  selectedReturnProducts,
  returnShipments,
  onAddSelectedProducts, 
  onSubmitReturnExchange, 
  onCancelReturnExchange 
}) => {
  const columns = useMemo(
    () => [
      {
        Header: "PRODUCT ID",
        accessor: "product_id",
      },
      {
        Header: "NAME", 
        accessor: "name",
      },
      {
        Header: "QUANTITY",
        accessor: "quantity",
      },
      {
        Header: "DESTINATION",
        accessor: "destination",
      },
    ],
    []
  )

  const data = useMemo(() => 
    returnShipments.map(product => ({
      ...product,
      destination: "Cavetown Warehouse"
    })), 
    [returnShipments]
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  })

  return (
    <div
      className="table-responsive react-table mt-1"
      style={{ maxHeight: "650px" }}
    >
      <Table {...getTableProps()} className="custom-header-css">
        <thead className="table-light table-head">
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              <Stack display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <h5 style={{ fontSize: "14px", margin: 0 }}>
                  Return shipment
                </h5>
                <div className='d-flex justify-content-between align-items-center'>
                  <h5 style={{ fontSize: "14px", margin: 0 }} className="me-3">Delivery Partner : Jos Dusseldorp</h5>
                  <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={onAddSelectedProducts}
                            disabled={selectedReturnProducts.length === 0}
                          >
                            Add Selected Products
                          </button>
                          <button
                            type="button"
                            className="ms-2 btn btn-primary waves-effect waves-light btn btn-primary"
                            onClick={onSubmitReturnExchange}
                            disabled={returnShipments.length === 0}
                          >
                            Submit
                          </button>
                      <button
                      type="button"
                      className="btn btn-danger waves-effect waves-light"
                      onClick={onCancelReturnExchange}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Stack>
            </tr>
          ))}
        </thead>
        <tbody>
          <tr>
            <td colSpan={3}>
              <Table
                {...getTableProps()}
                className="custom-header-css add-move-shipment-table"
              >
                <thead className="table-light table-head">
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, i) => {
                        return (
                          <th key={i} {...column.getHeaderProps()}>
                            <div style={{ minHeight: "unset" }}>
                              {column.render("Header")}
                            </div>
                          </th>
                        )
                      })}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows && rows?.length > 0 ? (
                    rows.map((row, i) => {
                      prepareRow(row)
                      return (
                        <tr key={i} {...row.getRowProps()}>
                          {row.cells.map((cell, i) => {
                            return (
                              <td
                                style={{ fontSize: 12 }}
                                key={i}
                                {...cell.getCellProps()}
                              >
                                {cell.render("Cell")}
                              </td>
                            )
                          })}
                        </tr>
                      )
                    })
                        ) : (
                          <tr>
                            <td colSpan="4" className="no-found-data">
                              No products added to return shipment yet
                            </td>
                          </tr>
                        )}
                </tbody>
              </Table>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

export default ReturnShipmentTable
